import FirebaseProvider from '../services/FirebaseAnalytics'

const firebaseProvider = FirebaseProvider.getInstance()

export const trackPage = (page: string) => {
  firebaseProvider.trackView(page)
}

export const trackEvent = (name: string, params: any | null) => {
  firebaseProvider.trackEvent(name, params)
}